/* eslint-disable no-inline-comments */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const rightsholders = () => import(/* webpackChunkName: "apppages" */ '@/pages/Rightsholders.vue');
const statements = () => import(/* webpackChunkName: "apppages" */ '@/pages/Statements.vue');
const currentRights = () => import(/* webpackChunkName: "apppages" */ '@/pages/CurrentRights.vue');
const unclaimedRights = () => import(/* webpackChunkName: "apppages" */ '@/pages/UnclaimedRights.vue');
const stagingArea = () => import(/* webpackChunkName: "apppages" */ '@/pages/StagingArea.vue');
const claimForms = () => import(/* webpackChunkName: "apppages" */ '@/pages/ClaimForms');
const uploadedFiles = () => import(/* webpackChunkName: "apppages" */ '@/pages/UploadedFiles.vue');


const routes = [
  {
    path: '/',
    name: 'AppStart',
    meta: {
      title: 'home.pageTitle'
    },
    // eslint-disable-next-line no-inline-comments
    component: () =>
      import(
        /* webpackChunkName: "apppages" */ '@/pages/Start'
      )
  },
  {
    path: '/info',
    name: 'AppInfo',
    meta: {
      title: 'App Info'
    },
    // eslint-disable-next-line no-inline-comments
  },
  {
    path: '/login',
    name: 'AppLogin',
    // eslint-disable-next-line no-inline-comments
    component: () =>
      import(
        /* webpackChunkName: "apppages" */ '@/pages/Login'
      )
  },
  {
    path: '/documents',
    name: 'AppDocuments',
    meta: {
      title: 'docs.pageTitle'
    },
    // eslint-disable-next-line no-inline-comments
    component: () =>
      import(
        /* webpackChunkName: "apppages" */ '@/pages/Documents'
      )
  },
  {
    path: '/dummygrid',
    name: 'DummyGrid',
    // eslint-disable-next-line no-inline-comments
    component: () =>
      import(
        /* webpackChunkName: "dummypages" */ '@/pages/DummyGrid'
      )
  },
  {
    path: '/dojo',
    name: 'FunctionDojo',
    // eslint-disable-next-line no-inline-comments
    component: () =>
      import(
        /* webpackChunkName: "dummypages" */ '@/pages/FunctionDojo'
      )
  },
  {
    path: '/griddojo',
    name: 'GridDojo',
    // eslint-disable-next-line no-inline-comments
    component: () =>
      import(
        /* webpackChunkName: "dummypages" */ '@/pages/GridDojo'
      )
  },
  {
    path: '/rightsholders',
    name: 'Rightsholders',
    component: rightsholders,
    meta: {
      title: 'rightsholders.pageTitle'
    },
  }, 
  {
    path: '/statements',
    name: 'Statements',
    component: statements,
    meta: {
      title: 'statements.pageTitle'
    }
  }, 
  {
    path: '/current-rights',
    name: 'CurrentRights',
    component: currentRights,
    meta: { title: 'currentRights.pageTitle' },
  },
  {
    path: '/current-rights/action-required',
    name: 'CurrentRightsActionRequired',
    component: currentRights,
    meta: { title: 'currentRights.pageTitle' },
  },
  {
    path: '/current-rights/double-claims',
    name: 'CurrentRightsDoubleClaims',
    component: currentRights,
    meta: { title: 'currentRights.pageTitle' },
  },
  {
    path: '/unclaimed-rights',
    name: 'UnclaimedRights',
    component: unclaimedRights,
    meta: {
      title: 'unclaimed.pageTitle'
    },
  },
  {
    path: '/staging',
    name: 'StagingArea',
    component: stagingArea,
    meta: {
      title: 'staging.pageTitle'
    }
  },
  {
    path: '/claim-forms',
    name: 'ClaimForms',
    component: claimForms,
    meta: {
      title: 'claimforms.pageTitle'
    }
  },
  {
    path: '/uploaded-files',
    name: 'UploadedFiles',
    component: uploadedFiles,
    meta: {
      title: 'uploads.pageTitle'
    }
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () =>
      import(
        /* webpackChunkName: "apppages" */ '@/pages/VerifyEmail'
      )
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes
})

export default router